export default function Donation() {
    {
        /* TO DO: Replace link */
    }
    return (
        <a href="http://www.noradio.org/" target="_blank" rel="noreferrer" className="Donation">
            <img src="/podpri_nas.svg" />
        </a>
    );
}
